import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'ADD_HEALTH_CHECK_POST',
  POST_SUCCESS: 'ADD_HEALTH_CHECK_POST_SUCCESS',
  POST_FAILURE: 'ADD_HEALTH_CHECK_POST_FAILURE',
};

export const post = actions.post(() => `${BASE_URL}/system-health-check/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
